<template>
  <div class="my-course">
    <h5 class="my-course-title">我的课程</h5>
    <div v-if="!loading && finished && list.length===0" class="empty-study">
      <img :src="studyImg" alt="">
      <p v-if="isLogin !== '' && isLogin !== undefined">你没有报名的课程</p>
      <p v-if="isLogin === '' || isLogin === undefined">登录后才能查看课程</p>
      <van-button v-if="isLogin === '' || isLogin === undefined" type="info" @click="toLogin">立即登录</van-button>
    </div>
    <van-pull-refresh v-model="refreshing" :head-height="97" @refresh="onRefresh">
      <template #loosing>
        <img :src="gifImg" class="doge" >
        <div class="loading-tip">
          <p>下拉可以刷新</p>
          <p>最后更新：{{ myCourseRefreshTime }}</p>
        </div>
      </template>
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        @load="onLoad"
      >
        <div class="c-content">
          <course-component v-for="item in list" :key="item.classId" :student-id="studentId" :obj="item" />
        </div>
      </van-list>
      <!-- <van-list
        v-model="loading"
        :finished="finished"
        :offset="20"
        :error.sync="error"
        @load="onLoad"
      >
        <div class="c-content">
          <course-component v-for="item in list" :key="item.classId" :student-id="studentId" :obj="item" />
        </div>
      </van-list> -->
    </van-pull-refresh>
  </div>
</template>

<script>
import { getNowTime } from '@/utils/util';
import { getToken, removeUserRegisterInfo } from '@/utils/auth';
import courseComponent from '../../components/study/course.vue';
import { PullRefresh, List, Button } from 'vant';

export default {
  name: 'StudyMyCourse',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Button.name]: Button,
    courseComponent
  },
  props: {
    studentId: {
      type: String,
      default: ''
    },
    pageLoading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      gifImg: require('@/assets/img/course/pic_refresh.gif'),
      studyImg: require('@/assets/img/empty_study.png'),
      myCourseRefreshTime: localStorage.getItem('myCourseRefreshTime') || '',
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      isLogin: getToken() || ''
    };
  },
  watch: {
    studentId(val) {
      if (val !== 'null' && val !== '') {
        this.list = [];
        this.finished = false;
        this.loading = true;
        this.totalCount = 0;
        this.pageNum = 1;
        console.log('studentId');
        this.onLoad();
      }
    }
  },
  created() {
    let saveTime = getNowTime().substring(5, 16);
    localStorage.setItem('myCourseRefreshTime', saveTime);
    this.myCourseRefreshTime = saveTime;
  },
  methods: {
    // 未登录，跳转登录页面
    toLogin() {
      removeUserRegisterInfo();
      location.href = '/login?redirect=' + this.$route.fullPath;
    },
    // 重新加载数据
    reGetData() {
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.totalCount = 0;
      this.pageNum = 1;
      this.onLoad();
    },
    getDatav2() {
      this.$store.dispatch('getMyCoursev2', { studentId: this.studentId }).then(res => {
        this.loading = false;
        this.finished = true;
        if (res.code === 200) {
          this.list = res.data;
        }
        this.$emit('change-loading', false);
      }).catch(() => {
        this.loading = false;
        this.finished = true;
        this.list = [];
        this.$emit('change-loading', false);
      });
    },
    getData() {
      this.$store.dispatch('getMyCourse', { pageNum: this.pageNum, pageSize: this.pageSize, studentId: this.studentId }).then(res => {
        if (res.code === 200) {
          if (this.pageNum === 1 && res.data.total === 0) {
            this.list = [];
            this.finished = true;
          }
          this.list = this.list.concat(res.data.records);
          this.totalCount = res.data.total || 0;
          if (this.totalCount <= this.pageNum * this.pageSize) {
            this.finished = true;
          } else {
            this.pageNum += 1;
          }
          this.loading = false;
        } else {
          this.loading = false;
          this.error = true;
        }
        this.$emit('change-loading', false);
        // this.list = [
        //   {
        //     classId: 432,
        //     coverUrl: 'https://res-hlwx.oss-cn-hangzhou.aliyuncs.com/mingyouOMO/test/939ebd8c3e3e447195cf2c5966d2321b.png',
        //     verifyStatus: '2',
        //     className: '我是一个开发课程',
        //     studyCount: 12,
        //     type: 2
        //   }
        // ];
      }).catch(() => {
        this.loading = false;
        this.error = true;
        this.list = [];
        this.finished = true;
        this.$emit('change-loading', false);
      });
    },
    onLoad() {
      if (this.studentId !== 'null' && this.studentId !== '') {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        console.log(4444444);
        this.loading = true;
        // this.getData();
        this.getDatav2();
      }
      if (!this.isLogin) {
        this.loading = false;
        this.finished = true;
        this.list = [];
      }
    },
    onRefresh() {
      let saveTime = getNowTime().substring(5, 16);
      localStorage.setItem('myCourseRefreshTime', saveTime);
      this.myCourseRefreshTime = saveTime;
      this.list = [];
      this.finished = false;
      console.log(55555);
      this.loading = true;
      this.totalCount = 0;
      this.pageNum = 1;
      console.log('onrefresh');
      this.onLoad();
    }
  }
};
</script>

<style lang="scss" scoped>
.my-course {
  width: 100%;
  position: relative;
  padding: 116px 0 140px;
  background: #fff;

  &-title {
    position: absolute;
    top: 28px;
    left: 36px;
    height: 50px;
    color: rgba(0,0,0,0.85);
    font-size: 36px;
    font-weight: bold;
    line-height: 50px;
  }

  .van-list {
    min-height: 80vh;
  }

  .c-content {
    width: 100%;
    padding: 0 36px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .course-component {
    width: 320px;
    height: 360px;
    background: $white;
    border-radius: 10px;
    margin-bottom: 20px;
    position: relative;
    box-shadow: 0px 4px 20px 5px rgba(0,0,0,0.1);

    /deep/ .course-img {
      display: inline-block;
      width: 100%;
      height: 176px;
      border-radius: 10px 10px 0 0;
      vertical-align: middle;
    }

    /deep/ .course-title {
      font-size: 30px;
      color: #1e1e1e;
      font-weight: bold;
      height: 90px;
      padding: 0 20px;
      margin: 18px 0 16px;
      line-height: 45px;

      @extend .text-overflow;
    }

    /deep/ .study-detail {
      position: absolute;
      display: flex;
      justify-content: space-between;
      align-items: center;
      bottom: 22px;
      width: 100%;
      color: #9f9f9f;
      font-size: 28px;
      padding: 0 12px;
    }
  }

  /deep/ .van-pull-refresh__head {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  >>> .loading-tip {
    text-align: left;
    margin-left: 24px;

    p {
      font-size: 28px;
      color: #9f9f9f;
      height: 40px;
      line-height: 40px;
    }

    p:first-child {
      color: #1e1e1e;
    }
  }

  .doge {
    height: 70px;
  }

  .empty-study {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #b0b0b0;
    padding-top: 166px;

    button {
      height: 76px;
      width: 240px;
      text-align: center;
      border-radius: 38px;
      background: $blue;
      color: $white;
      margin-top: 64px;
      font-size: 28px;
      font-weight: bold;
    }

    img {
      width: 500px;
      padding-bottom: 4px;
    }

    p {
      font-size: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/study/my-course.vue